import { render, staticRenderFns } from "./facilities.vue?vue&type=template&id=a4291398&scoped=true"
import script from "./facilities.vue?vue&type=script&lang=js"
export * from "./facilities.vue?vue&type=script&lang=js"
import style0 from "./facilities.vue?vue&type=style&index=0&id=a4291398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4291398",
  null
  
)

export default component.exports